export const COMPANY_CREATED = "company.created" as const;
export const CONTACT_CREATED = "contact.created" as const;
export const CONTACT_NOTE_CREATED = "contactNote.created" as const;
